<div class="mot-time-picker-host" [class.mot-time-picker-rtl]="direction === 'rtl'">
  <mat-form-field
    [appearance]="appearance"
    [class]="class"
    [dir]="direction"
    [floatLabel]="floatLabelType"
    >
    @if (label) {
      <mat-label [dir]="direction" class="text-sm">{{ label }}</mat-label>
    }

    <!--
      a11y: error link uses property binding [aria-describedby] (NOT [attr.aria-describedby])
      so MatInput's @Input('aria-describedby') setter fires; MatFormField then merges the id
      via _syncDescribedByIds(). Using [attr.] would write the DOM directly and be wiped on
      Material's next sync (it removes the attribute when userAriaDescribedBy is empty).
      aria-invalid mirrors the (touched && invalid) state so SR users hear the field is in error.
    -->
    <input
      matInput
      [value]="isInputFocused ? inputValue : displayValue"
      [placeholder]="placeholder"
      class="mot-time-picker-input"
      dir="ltr"
      (focus)="onInputFocus(); $event.stopPropagation()"
      (blur)="onInputBlur($event)"
      (input)="onTimeInput($event)"
      (click)="onInputClick(); $event.stopPropagation()"
      [aria-describedby]="(formControl?.invalid && formControl?.touched && displayErrors) ? errorId : null"
      [attr.aria-invalid]="(formControl?.invalid && formControl?.touched) ? 'true' : null"
      />

      @if (!icon) {
        <button
          matSuffix
          type="button"
          class="mot-time-picker-trigger-icon !min-w-0 !p-0 !border-0 !bg-transparent"
          [class.ml-2]="direction === 'rtl'"
          [class.mr-2]="direction === 'ltr'"
          [attr.aria-label]="selectTimeAriaLabel"
          (click)="openPanel(); $event.stopPropagation()"
        >
          <mat-icon aria-hidden="true">schedule</mat-icon>
        </button>
      }
      @if (icon) {
        <button
          matSuffix
          type="button"
          class="mot-time-picker-trigger-icon !min-w-0 !p-0 !border-0 !bg-transparent"
          [class.ml-2]="direction === 'rtl'"
          [class.mr-2]="direction === 'ltr'"
          [attr.aria-label]="selectTimeAriaLabel"
          (click)="handleIconClick($event); openPanel(); $event.stopPropagation()"
        >
          <ng-icon
            [dir]="direction"
            [name]="icon"
            [class]="iconClass || 'text-2xl'"
            aria-hidden="true"
          ></ng-icon>
        </button>
      }
    </mat-form-field>

    @if (panelOpen) {
      <div
        class="mot-time-picker-panel"
        role="dialog"
        dir="ltr"
        (click)="$event.stopPropagation()"
        >
        <div class="mot-time-picker-panel-body">
          <!--
            Real <button> elements so each chevron exposes role=button + accessible name to AT.
            tabindex="-1" keeps Tab order on the input itself (steppers reachable via click/touch);
            keyboard users edit the value through the input field directly.
          -->
          <div class="mot-time-picker-spinner">
            <button type="button" class="mot-time-picker-chevron" tabindex="-1"
              [attr.aria-label]="increaseHourAriaLabel" (click)="stepHour(1)">
              <mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon>
            </button>
            <span class="mot-time-picker-value" aria-live="polite">{{ hourControl.value }}</span>
            <button type="button" class="mot-time-picker-chevron" tabindex="-1"
              [attr.aria-label]="decreaseHourAriaLabel" (click)="stepHour(-1)">
              <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
            </button>
          </div>
          <span class="mot-time-picker-colon" aria-hidden="true">:</span>
          <div class="mot-time-picker-spinner">
            <button type="button" class="mot-time-picker-chevron" tabindex="-1"
              [attr.aria-label]="increaseMinuteAriaLabel" (click)="stepMinute(1)">
              <mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon>
            </button>
            <span class="mot-time-picker-value" aria-live="polite">{{ minuteControl.value }}</span>
            <button type="button" class="mot-time-picker-chevron" tabindex="-1"
              [attr.aria-label]="decreaseMinuteAriaLabel" (click)="stepMinute(-1)">
              <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
  </div>

  @if (formControl?.invalid && formControl?.touched && displayErrors) {
    <!-- role=alert + aria-live=assertive: when the error appears (e.g. after typing past time and blur), SR announces it immediately. -->
    <mat-error
      [id]="errorId"
      class="mot-time-picker-error"
      role="alert"
      aria-live="assertive"
      [ngStyle]="{ 'text-align': direction === 'rtl' ? 'right' : 'left' }"
      >
      {{ getFirstError() }}
    </mat-error>
  }
